import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import kidolaLogo from '../../assets/Logo Kidola PNG.png'; // logo kecil
import kidolaBackground from '../../assets/kidolaBackground.png'; 
import kidolaBackground2 from '../../assets/kidolaBackground-2.png'; 
import moment from 'moment';
import 'moment/locale/id';
// pastikan install moment: npm install moment

const bulanIndo = [
  'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
  'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
];

const convertNumberToWordsID = (number) => {
  const satuan = ['', 'Satu', 'Dua', 'Tiga', 'Empat', 'Lima', 'Enam', 'Tujuh', 'Delapan', 'Sembilan', 'Sepuluh', 'Sebelas'];
  if (number < 12) return satuan[number];
  if (number < 20) return satuan[number - 10] + ' Belas';
  if (number < 100) return satuan[Math.floor(number / 10)] + ' Puluh ' + satuan[number % 10];
  if (number < 200) return 'Seratus ' + convertNumberToWordsID(number - 100);
  if (number < 1000) return satuan[Math.floor(number / 100)] + ' Ratus ' + convertNumberToWordsID(number % 100);
  if (number < 2000) return 'Seribu ' + convertNumberToWordsID(number - 1000);
  if (number < 1000000) return convertNumberToWordsID(Math.floor(number / 1000)) + ' Ribu ' + convertNumberToWordsID(number % 1000);
  return 'Angka terlalu besar';
};

export const generatePaymentReceiptPDF = (student, paymentData, paymentDetails, paymentDate, type) => {
  const height = type === 'NEW' ? 700 : 595
  const doc = new jsPDF({ unit: 'pt', format: [595, height] });
  const pageWidth = doc.internal.pageSize.getWidth();

  // Background
  doc.addImage(type === 'NEW' ? kidolaBackground2 : kidolaBackground, 'PNG', 0, 0, 600, height);
  // Logo
  doc.addImage(kidolaLogo, 'PNG', 40, 30, 70, 70);

  // Title
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(22);
  doc.setTextColor(216, 47, 126);
  doc.text('Kidola Learning Centre', pageWidth / 2, 60, { align: 'center' });

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(16);
  doc.text('Payment Receipt', pageWidth / 2, 90, { align: 'center' });

  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.5);
  doc.line(40, 120, pageWidth - 40, 120);

  // Received From
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(14);
  doc.setTextColor(0, 0, 0);
  doc.text('Received From', 40, 150);

  autoTable(doc, {
    startY: 160,
    body: [
      ['Name', student.student_name || '-'],
      ['Student ID', student.student_code || '-'],
      ['Payment Date', moment(paymentDate).locale('id').format('D MMMM YYYY')],
      ['Payment Method', paymentData.paymentMethod || '-']
    ],
    theme: 'grid',
    styles: { 
      fillColor: false,
      fontSize: 11, 
      textColor: [0, 0, 0] 
    },
    columnStyles: {
      0: { cellWidth: 150 },
      1: { cellWidth: 'auto' }
    },
    tableLineColor: [0, 0, 0],
    tableLineWidth: 0.3,
    head: []
  });

  // Payment Details
  const paymentDetailStartY = doc.lastAutoTable.finalY + 20;

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.setTextColor(0, 0, 0);
  doc.text('Payment Details', 40, paymentDetailStartY);

  const paymentTableData = paymentDetails.map((item, index) => {
    return [
      `${index + 1}. ${item.item || '-'}`,
      `Rp ${Number(item.amount).toLocaleString('id-ID')}`
    ];
  });

  autoTable(doc, {
    startY: paymentDetailStartY + 10,
    head: [['Description', 'Amount']],
    body: paymentTableData,
    theme: 'grid',
    styles: { 
      fillColor: false,
      fontSize: 12, 
      textColor: [0, 0, 0] 
    },
    headStyles: { fillColor: false, textColor: [0, 0, 0], fontStyle: 'bold' },
    columnStyles: {
      0: { cellWidth: 300 },
      1: { cellWidth: 'auto', halign: 'right' }
    },
    tableLineColor: [0, 0, 0],
    tableLineWidth: 0.3
  });

  // Total Amount
  const afterTableY = doc.lastAutoTable.finalY + 20;
  const totalAmount = paymentDetails.reduce((sum, item) => sum + Number(item.amount || 0), 0);

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(14);
  doc.setTextColor(0, 0, 0);
  doc.text(`Total Amount Paid : Rp ${totalAmount.toLocaleString('id-ID')}`, 40, afterTableY);

  // Terbilang
  doc.setFont('helvetica', 'italic');
  doc.setFontSize(14);
  const terbilang = convertNumberToWordsID(totalAmount).replace(/\s+/g, ' ').trim();
  doc.text(`Terbilang : ${terbilang} Rupiah`, 40, afterTableY + 20);

  // Footer
  const footerY = afterTableY + 100;
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(14);
  doc.setTextColor(0, 73, 83);
  doc.text('Thank You for', 40, footerY);
  doc.text('Your Payment!', 40, footerY + 15);

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(14);
  doc.setTextColor(0, 0, 0);
  doc.text('Miss Lala', pageWidth - 120, footerY);
  doc.text('School Administrator', pageWidth - 160, footerY + 15);

  let receiptType = 'spp';
  if (type === 'LEVELUP'){
    receiptType = 'student_level_up';
  } else if (type === 'MODUL') {
    receiptType = 'modul';
  } else if (type === 'GRADUATION') {
    receiptType = 'graduation';
  } else if (type === 'NEW') {
    receiptType = 'new_student';
  } else if (type === 'CLASS') {
    receiptType = 'class';
  } 

  const filename = `${student.student_name}_${student.student_code}_${receiptType}_receipt.pdf`;
  return doc.save(filename, { returnPromise: true });
};
